import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HandleError, HttpErrorHandlerService } from './http-error-handler.service';
import { MessageService } from './message.service';
import { PdpApiConstants as ApiConstants } from './pdp-api-constants';

@Injectable({
    providedIn: 'root',
})
export class pdpApiService {
    private headers: HttpHeaders;
    tipsObs = new Subject();
    vTitle: any[] = [];
    tipsList: any[] = [];
    searchlist = [];
    searchObs = new Subject();
    token: string = "3eb572daad1032b8077097f7963a889f:9P3Un4z94S"
    private handleError: HandleError;
    // using
    data$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    update(value: string) {
        this.data$.next(value);
    }

    // using
    route$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    routeData(value: string) {
        this.route$.next(value);
    }

    //search data
    search$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    onDataSearch(value: string) {
        this.search$.next(value);
    }

    constructor(
        private httpClient: HttpClient,
        private massageService: MessageService,
        httpErrorHandler: HttpErrorHandlerService, private route: ActivatedRoute,
    ) {
        this.headers = new HttpHeaders({
            Accept: '*/*',
            'Content-Type': 'application/json',
            'x-language': localStorage.getItem('language')?.toUpperCase() ?? 'ID',
        });

        this.handleError = httpErrorHandler.createHandleError('PdpApiService');
    }

    generateOtp(msisdn?: any, msisdnType?: any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            api_key: this.massageService.getSignatureObject().api_key,
            "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.OTP_MASHERY}`;
        let body = {
            // TransactionID: this.massageService.getTransactionId(),
            Source: "CUSTCONSENT_WEB",
            // RequestID: "VALIDATE_MSISDN",
            // RequestType: "GENERATE_OTP",
            // OTP: null,
            msisdn: msisdn,
            // ICCID: "",
            // NIK: "",
            INParam1: msisdnType,
            // INParam2: ""
        };

        return this.httpClient.post<any>(url, body, {
            headers: headers,
        });
    }

    validateOtp(msisdn?: any, msisdnType?: any, otp?: any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            api_key: this.massageService.getSignatureObject().api_key,
            "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.OTP_MASHERY1}`;
        let body = {
            // TransactionID: this.massageService.getTransactionId(),
            Source: "CUSTCONSENT_WEB",
            // RequestID: "VALIDATE_MSISDN",
            // RequestType: "VALIDATE_OTP",
            OTP: otp,
            msisdn: msisdn,
            // ICCID: "",
            // NIK: "",
            INParam1: msisdnType,
            // INParam2: null
        };
        return this.httpClient.post<any>(url, body, {
            headers: headers,
        });
    }

    fetchConsent(msisdn?: any, signature: any = ""): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            // api_key: this.massageService.getSignatureObject().api_key,
            // "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.FETCH_CONSENT}`;
        let body = {
            //TransactionID: this.massageService.getTransactionId(),
            Source: 'pdpweb',
            //RequestType: "getConsent",
            //RequestID: "query",
            msisdn: msisdn,
            // INParam1: "",
            // INParam2: "",
            signature: signature
        };
        return this.httpClient.post<any>(url, body, {
            headers: headers,
        });
    }

    updateConsent(data?:any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            // api_key: this.massageService.getSignatureObject().api_key,
            // "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.UPDATE_CONSENT}`;
        data.Source = 'pdpweb'
        // let body = {
        //     TransactionID: this.massageService.getTransactionId(),
        //     Source: localStorage.getItem('source'),
        //     RequestType: "createConsent",
        //     RequestID: "create",
        //     msisdn: msisdn,
        //     // INParam1: "",
        //     // INParam2: "",
        //     consentList: consentList,
        //     signature: signature
        // };
        return this.httpClient.post<any>(url, data, {
            headers: headers,
        });
    }

    validateHash(hash?: any, timestamp?: any, msisdn?: any, jwt_client?: any, usertype?: any, language?: any, channel?:any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            // api_key: this.massageService.getSignatureObject().api_key,
            // "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.VALIDATE_HASH}`;

        let body = {
            hash: hash,
            timestamp: timestamp,
            msisdn: msisdn,
            jwt_client: jwt_client,
            usertype: usertype,
            language: language,
            channel: channel
        };

        return this.httpClient.post<any>(url, body, {
            headers: headers,
        });
    }

    fetchConsentHash(msisdn?: any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            // api_key: this.massageService.getSignatureObject().api_key,
            // "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.FETCH_CONSENT_HASH}`;
        let body = {
            // TransactionID: this.massageService.getTransactionId(),
            Source: 'pdpweb',
            // RequestType: "getConsent",
            // RequestID: "query",
            msisdn: msisdn,
            // INParam1: "",
            // INParam2: "",
        };
        return this.httpClient.post<any>(url, body, {
            headers: headers,
        });
    }

    updateConsentHash(data?: any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.token,
            // api_key: this.massageService.getSignatureObject().api_key,
            // "X-Signature": this.massageService.getSignatureObject().sig,
        });
        let url = `${ApiConstants.UPDATE_CONSENT_HASH}`;
        
        // let body = {
        //     // TransactionID: this.massageService.getTransactionId(),
        //     Source: localStorage.getItem('source'),
        //     // RequestType: "createConsent",
        //     // RequestID: "create",
        //     msisdn: msisdn,
        //     // INParam1: "",
        //     // INParam2: "",
        //     consentList: consentList,
        // };
        return this.httpClient.post<any>(url, data, {
            headers: headers,
        });
    }

}
